// Types
import { Column } from '../objects/column';
import { DestinationState } from '../objects/destinationState';
import { Preferences } from '../../profile/objects/preferences';
import { DestinationLocalized } from '../objects/destinationLocalized';
// Action Types
import {
    ADD_PREFERENCES,
    DELETE_DESTINATION_PICTURE,
    DestinationActionTypes,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_ADD_DESTINATION,
    RESET_FILTERS,
    SET_DESTINATION,
    SET_DESTINATION_VERSION,
    SET_EDIT_STEP,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PREFERENCES as SET_DESTINATION_PREFERENCES,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_CANCEL_MODAL,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_DESTINATION_PICTURES_ORDER,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_HOMEPAGE_DISPLAY,
    TOGGLE_REFRESH,
    UPDATE_CALENDAR_ID,
    UPDATE_CATEGORY,
    UPDATE_CURRENCY,
    UPDATE_DESTINATION_NAME_LOCALE,
    UPDATE_DESTINATION_PICTURE_ORDER,
    UPDATE_DESTINATION_SEARCH,
    UPDATE_DESTINATION_TYPE,
    UPDATE_DURATION_DAYS,
    UPDATE_DURATION_HOURS,
    UPDATE_DURATION_MINUTES,
    UPDATE_FILTER_COUNTRY,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_DESTINATION,
    UPDATE_FILTER_DESTINATION_SEARCH,
    UPDATE_FILTER_DESTINATION_TYPE,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PARENT,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_FILTER_PICTURES,
    UPDATE_FILTER_STATUS,
    UPDATE_GOOGLE_ID,
    UPDATE_LATITUDE,
    UPDATE_LIST_ITEM_VISIBILITY,
    UPDATE_LOCATION,
    UPDATE_LONGITUDE,
    UPDATE_MAP,
    UPDATE_NAME,
    UPDATE_NAME_ERROR,
    UPDATE_PARENT,
    UPDATE_PUBLISH_DATE,
    UPDATE_PUBLISH_TIME,
    UPDATE_RATING,
    UPDATE_TO_USER,
    UPDATE_VISIBILITY,
    UPDATE_VIDEO_LINK,
    UPDATE_EMAIL,
    UPDATE_ZOOM,
    INIT_DESTINATION_PICTURE,
    SET_COLUMNS,
    SET_CHECKING_NAME_ERROR,
    TOGGLE_AT_SEA
} from './actionTypes';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { ADD_CUSTOM_PICTURES, PictureActionTypes, SET_PICTURE } from '../../picture/redux/actionTypes';

const initialState: DestinationState = {
    columns: [{
        label: 'name',
        field_name: 'NAME',
        checked: true,
        order_by: 'current_version__localization__name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'country',
        field_name: 'COUNTRY',
        checked: true,
        order_by: 'current_version__country__localization__name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'parent',
        field_name: 'PARENT',
        checked: true,
        order_by: 'parent__current_version__localization__name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'destination-type',
        field_name: 'TYPE',
        checked: true,
        order_by: 'current_version__type',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'picture',
        field_name: 'PICTURES',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'online-to',
        field_name: 'VISIBILITY',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'online-agency',
        field_name: 'AGENCY_VISIBILITY',
        checked: true,
        order_by: '',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }],
    calendar_id: null,
    calendar_error: '',
    category: [],
    cancel_modal: false,
    count: 0,
    create: false,
    currency: null,
    currency_error: '',
    destination_name_locales: {},
    destination_pictures: [],
    destination_pictures_order: false,
    destination_search: null,
    destination_type: 4,
    destination: null,
    duration_error: '',
    duration_days: 0,
    duration_hours: 0,
    duration_minutes: 0,
    edit_pictures: '',
    edit_step: null,
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_country: [],
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_destination_search: 'DESTINATION',
    filter_destination_type: -1,
    filter_destination: null,
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_parent: [],
    filter_period_type: 0,
    filter_period: 'CREATION',
    filter_pictures: 0,
    filter_status: 'ALL',
    google_id_error: '',
    google_id: '',
    homepage_display: false,
    at_sea: false,
    latitude_error: '',
    latitude: 48.8596169155,
    limit: 50,
    list: null,
    longitude_error: '',
    longitude: 2.3564089625,
    rating: 5,
    map: null,
    name_error: '',
    name: '',
    order_by: 'name',
    order: 'asc',
    page: 0,
    parent: null,
    parent_error: '',
    preferences: [],
    publish_date: null,
    publish_time: null,
    private_until: null,
    refresh: false,
    running: false,
    search: '',
    to_user: null,
    contact_email: '',
    visibility: 0,
    video_link: '',
    zoom: 8,
    checking_name_error: false
};

export default (state: DestinationState = initialState, action: DestinationActionTypes | ProfileActionTypes | PictureActionTypes): DestinationState => {
    switch (action.type) {
        case SET_CHECKING_NAME_ERROR: {
            return {...state, checking_name_error: action.payload};
        }
        case ADD_PREFERENCES: {
            return {...state, preferences: [...state.preferences, ...action.payload]};
        }
        case INIT_DESTINATION_PICTURE : {
            return {...state, destination_pictures: []}
        }
        case ADD_CUSTOM_PICTURES: {
            return {...state, destination_pictures: [...state.destination_pictures, ...action.payload]};
        }
        case DELETE_DESTINATION_PICTURE: {
            let destination_pictures = [...state.destination_pictures];
            destination_pictures.splice(action.payload, 1);
            return {...state, destination_pictures: destination_pictures};
        }
        case MOVE_DOWN_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload + 1]};
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case MOVE_UP_COLUMN: {
            let columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            let column = {...columns[action.payload - 1]};
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case RESET_ADD_DESTINATION: {
            return {
                ...state,
                calendar_id: null,
                calendar_error: '',
                category: [],
                create: false,
                currency: null,
                currency_error: '',
                destination_name_locales: {},
                destination_pictures: [],
                destination_pictures_order: false,
                destination_search: null,
                destination_type: 4,
                destination: null,
                duration_error: '',
                duration_days: 0,
                duration_hours: 0,
                duration_minutes: 0,
                edit_step: null,
                google_id_error: '',
                google_id: '',
                homepage_display: false,
                at_sea: false,
                latitude_error: '',
                latitude: 35.137879,
                longitude_error: '',
                longitude: -82.836914,
                map: null,
                cancel_modal: false,
                parent: null,
                parent_error: '',
                publish_date: null,
                publish_time: null,
                private_until: null,
                rating: 5,
                to_user: null,
                contact_email: '',
                visibility: 0,
                video_link: '',
                zoom: 8
            }
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_country: [],
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_destination: null,
                filter_destination_search: 'DESTINATION',
                filter_destination_type: -1,
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_parent: [],
                filter_period: 'CREATION',
                filter_period_type: 0,
                filter_status: 'ALL',
                filter_pictures: 0
            }
        }
        case SET_DESTINATION: {
            const destination = action.payload;
            const destination_data = destination.data;
            if (destination_data !== null) {
                let visibility = 0;
                switch (destination.visibility) {
                    case "PRIVATE":
                        visibility = 0;
                        break;
                    case "PRIVATE_TO":
                        visibility = 1;
                        break;
                    case "PUBLIC":
                        visibility = 2;
                        break;
                }
                if (destination.visibility === "PRIVATE" && destination.private_until !== null) {
                    visibility = 3;
                }
                const destination_name_locales: any & {[index: string]: any} = {};
                let has_name = false;
                destination_data.localization.map((locale: DestinationLocalized) => {
                    if (locale.name) {
                        has_name = true;
                    }
                    destination_name_locales[locale.locale] = locale.name;
                });
                if(!has_name){
                    destination_name_locales[1] = destination_data.name;
                }
                return {
                    ...state,
                    destination: destination,
                    edit_step: null,
                    calendar_id: destination_data.country,
                    category: destination.categories,
                    destination_name_locales: destination_name_locales,
                    destination_pictures: destination_data.pictures,
                    destination_type: destination_data.type,
                    duration_days: (destination_data.suggested_hours - (destination_data.suggested_hours % 24)) / 24,
                    duration_hours: destination_data.suggested_hours % 24,
                    duration_minutes: destination_data.suggested_minutes,
                    google_id: destination_data.places_id || "",
                    homepage_display: destination.display_homepage,
                    at_sea: destination.at_sea,
                    latitude: destination_data.latitude,
                    longitude: destination_data.longitude,
                    parent: destination.parent,
                    publish_date: destination.published_date,
                    publish_time: destination.private_until,
                    private_until: destination.private_until,
                    rating: destination_data.note,
                    to_user: destination.manager,
                    contact_email: destination.contact_email || '',
                    visibility: visibility,
                    video_link: destination.video_link || '',
                    zoom: destination_data.zoom_level
                };
            } else {
                return {...state, destination: action.payload}
            }
        }
        case SET_DESTINATION_VERSION: {
            let destination_name_locales: {} & {[index: string]: any} = {};
            let has_french = false;
            action.payload.localization.map((locale: DestinationLocalized) => {
                if (locale.locale === 1) {
                    has_french = true;
                }
                destination_name_locales[locale.locale] = locale.name
            });
            let destination = Object.assign({}, state.destination);
            destination.data = action.payload;
            return {
                ...state,
                destination: destination,
                calendar_id: action.payload.country,
                destination_name_locales: destination_name_locales,
                destination_pictures: action.payload.pictures,
                destination_type: action.payload.type,
                duration_days: Math.floor(action.payload.suggested_hours / 24),
                duration_hours: action.payload.suggested_hours % 24,
                duration_minutes: action.payload.suggested_minutes,
                google_id: action.payload.places_id || "",
                latitude: action.payload.latitude,
                longitude: action.payload.longitude,
                rating: action.payload.note,
                zoom: action.payload.zoom_level
            };
        }
        case SET_DESTINATION_PREFERENCES: {
            return {...state, preferences: action.payload};
        }
        case SET_EDIT_STEP: {
            return {...state, edit_step: action.payload}
        }
        case SET_ERRORS: {
            const errors = action.payload;
            const new_state: DestinationState = {...state};
            // new_state.name_error = '';
            // new_state.currency_error = '';
            // new_state.calendar_error = '';
            // new_state.destination_type_error = '';
            // new_state.category_error = '';
            // new_state.duration_error = '';
            // new_state.google_id_error = '';
            // new_state.latitude_error = '';
            // new_state.longitude_error = '';
            // new_state.parent_error = '';
            errors.map(error => {
                new_state[error.key] = error.error;
            });
            return {...new_state};
        }
        case SET_EXPORT_TYPE: {
            return {...state, export_type: action.payload}
        }
        case SET_LIMIT: {
            return {...state, list: null, limit: action.payload};
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return {...state, count: count, list: results, running: false};
        }
        case SET_ORDER_BY: {
            return {...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return {...state, list: null, page: action.payload};
        }
        case SET_PICTURE: {
            if (action.payload !== true && action.payload !== false) {
                let destination_pictures = [...state.destination_pictures];
                for (let i = 0; i < destination_pictures.length; i++) {
                    if (destination_pictures[i].id === action.payload.id) {
                        destination_pictures[i] = {...action.payload};
                        break;
                    }
                }
                return {...state, destination_pictures: destination_pictures};
            }
            return state;
        }
        case SET_PREFERENCES: {
            const preferences = action.payload;
            let new_columns: Column[] = [];
            let new_order_by = '-created_date';
            let new_order: 'asc' | 'desc' = 'asc';
            let field_name: string[] = [];
            let destination_preferences: Preferences[] = [];
            preferences.map(preference => {
                if (preference.module === 'DESTINATION') {
                    if (!field_name.includes(preference.field_name)) {
                        switch (preference.field_name) {
                        case 'NAME':
                            new_columns.push({label: 'name', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__localization__name', fixed_width: false, last_updated: false});
                            new_order_by = preference.ordering_asc !== null ? 'current_version__localization__name' : new_order_by;
                            break;
                        case 'COUNTRY':
                            new_columns.push({label: 'country', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__country__localization__name', fixed_width: false, last_updated: false});
                            new_order_by = preference.ordering_asc !== null ? 'current_version__country__localization__name' : new_order_by;
                            break;
                        case 'PARENT':
                            new_columns.push({label: 'parent', field_name: preference.field_name, checked: preference.active, order_by: 'parent__current_version__localization__name', fixed_width: false, last_updated: false});
                            new_order_by = preference.ordering_asc !== null ? 'parent__current_version__localization__name' : new_order_by;
                            break;
                        case 'TYPE':
                            new_columns.push({label: 'destination-type', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__type', fixed_width: false, last_updated: false});
                            new_order_by = preference.ordering_asc !== null ? 'current_version__type' : new_order_by;
                            break;
                        case 'PICTURES':
                            new_columns.push({label: 'picture', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: true, last_updated: false});
                            break;
                        case 'VISIBILITY':
                            new_columns.push({label: 'online-to', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: true, last_updated: false});
                            break;
                        case 'AGENCY_VISIBILITY':
                            new_columns.push({label: 'online-agency', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: true, last_updated: false});
                            break;
                        case 'CREATED_DATE':
                            new_columns.push({label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false});
                            new_order_by = preference.ordering_asc !== null ? 'created_date' : new_order_by;
                            break;
                        case 'CREATED_BY':
                            new_columns.push({label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false});
                            new_order_by = preference.ordering_asc !== null ? 'creator__username' : new_order_by;
                            break;
                        case 'MODIFIED_DATE':
                            new_columns.push({label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false});
                            new_order_by = preference.ordering_asc !== null ? 'modified_date' : new_order_by;
                            break;
                        case 'MODIFIED_BY':
                            new_columns.push({label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false});
                            new_order_by = preference.ordering_asc !== null ? 'last_author__username' : new_order_by;
                            break;
                        default:
                            break;
                        }
                        destination_preferences.push(preference);
                        field_name.push(preference.field_name);
                        new_order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : new_order;
                    }
                }
            });
            if (new_columns.length !== state.columns.length) {
                state.columns.map(column => {
                    let added = false;
                    for (let i = 0; i < new_columns.length; i++) {
                        if (new_columns[i].label === column.label) {
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        new_columns.push({...column});
                    }
                });
            }
            return {...state, preferences: destination_preferences, columns: new_columns, order_by: new_order_by, order: new_order};
        }
        case SET_RUNNING: {
            return {...state, running: action.payload};
        }
        case SET_SEARCH: {
            return {...state, list: null, page: 0, search: action.payload};
        }
        case TOGGLE_CANCEL_MODAL: {
            return {...state, cancel_modal: !state.cancel_modal};
        }
        case TOGGLE_COLUMN: {
            let columns = [...state.columns];
            let column = {...columns[action.payload]};
            column.checked = !column.checked;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case TOGGLE_CREATE: {
            return {...state, create: !state.create};
        }
        case TOGGLE_DESTINATION_PICTURES_ORDER: {
            return {...state, destination_pictures_order: !state.destination_pictures_order};
        }
        case TOGGLE_EXPORT: {
            return {...state, export_list: action.payload};
        }
        case TOGGLE_EXPORT_FULL: {
            return {...state, export_full: !state.export_full};
        }
        case TOGGLE_FILTERS: {
            return {...state, filter_open: !state.filter_open};
        }
        case TOGGLE_HOMEPAGE_DISPLAY: {
            return {...state, homepage_display: !state.homepage_display};
        }
        case TOGGLE_AT_SEA: {
            return {...state, at_sea: !state.at_sea};
        }
        case TOGGLE_REFRESH: {
            return {...state, refresh: !state.refresh};
        }
        case UPDATE_CALENDAR_ID: {
            return {...state, calendar_id: action.payload, calendar_error: ''};
        }
        case UPDATE_CATEGORY: {
            return {...state, category: action.payload, category_error: ''};
        }
        case UPDATE_CURRENCY: {
            return {...state, currency: action.payload, currency_error: ''};
        }
        case UPDATE_DESTINATION_NAME_LOCALE: {
            const { id, value } = action.payload;
            const destination_name_locales = {...state.destination_name_locales};
            destination_name_locales[id] = value;
            return {...state, destination_name_locales: destination_name_locales};
        }
        case UPDATE_DESTINATION_PICTURE_ORDER: {
            const { drag_index, hover_index } = action.payload;
            let destination_pictures = [...state.destination_pictures];
            destination_pictures.splice(drag_index, 1);
            destination_pictures.splice(hover_index, 0, state.destination_pictures[drag_index]);
            return {...state, destination_pictures: destination_pictures};
        }
        case UPDATE_DESTINATION_SEARCH: {
            const { id, value } = action.payload;
            const destination_name_locales = {...state.destination_name_locales};
            destination_name_locales[id] = value === null ? '' : value.description;
            if (state.create) {
                return {...state, destination_name_locales: destination_name_locales, google_id: value === null ? '' : value.place_id !== '' ? value.place_id : state.google_id, name_error: '', google_id_error: ''};
            } else if (state.edit_step === 'LOCATION') {
                return {...state, destination_name_locales: destination_name_locales, google_id: value === null ? '' : value.place_id !== '' ? value.place_id : state.google_id, name_error: '', google_id_error: ''};
            } else {
                return {...state, destination_name_locales: destination_name_locales, name_error: '', google_id_error: ''};
            }
        }
        case UPDATE_DESTINATION_TYPE: {
            return {...state, destination_type: action.payload, destination_type_error: ''};
        }
        case UPDATE_DURATION_DAYS: {
            return {...state, duration_days: action.payload, duration_error: ''};
        }
        case UPDATE_DURATION_HOURS: {
            return {...state, duration_hours: action.payload, duration_error: ''};
        }
        case UPDATE_DURATION_MINUTES: {
            return {...state, duration_minutes: action.payload, duration_error: ''};
        }
        case UPDATE_FILTER_COUNTRY: {
            return {...state, filter_country: action.payload};
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return {...state, filter_created_date_gte: action.payload};
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return {...state, filter_created_date_lte: action.payload};
        }
        case UPDATE_FILTER_CREATOR: {
            return {...state, filter_creator: action.payload};
        }
        case UPDATE_FILTER_DESTINATION: {
            return {...state, filter_destination: action.payload};
        }
        case UPDATE_FILTER_DESTINATION_SEARCH: {
            return {...state, filter_destination_search: action.payload, filter_destination: null, filter_parent: [], filter_country: []};
        }
        case UPDATE_FILTER_DESTINATION_TYPE: {
            return {...state, filter_destination_type: action.payload};
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return {...state, filter_last_author: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return {...state, filter_modified_date_gte: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return {...state, filter_modified_date_lte: action.payload};
        }
        case UPDATE_FILTER_PARENT: {
            return {...state, filter_parent: action.payload};
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return {...state, filter_period_type: action.payload};
        }
        case UPDATE_FILTER_PICTURES: {
            return {...state, filter_pictures: action.payload};
        }
        case UPDATE_FILTER_STATUS: {
            return {...state, filter_status: action.payload};
        }
        case UPDATE_GOOGLE_ID: {
            return {...state, google_id: action.payload || "", google_id_error: ''};
        }
        case UPDATE_LATITUDE: {
            return {...state, latitude: action.payload, latitude_error: ''};
        }
        case UPDATE_LIST_ITEM_VISIBILITY: {
            if (state.list !== null) {
                let list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === action.payload.id) {
                        list[i].visibility = action.payload.visibility;
                        break;
                    }
                }
                return {...state, list: list};
            }
            return state;
        }
        case UPDATE_LOCATION: {
            return {...state, google_id: action.payload.google_id || "", latitude: action.payload.latitude, longitude: action.payload.longitude, zoom: 11, google_id_error: '', latitude_error: '', longitude_error: ''};
        }
        case UPDATE_LONGITUDE: {
            return {...state, longitude: action.payload, longitude_error: ''};
        }
        case UPDATE_MAP: {
            return {...state, map: action.payload};
        }
        case UPDATE_NAME: {
            return {...state, name: action.payload};
        }
        case UPDATE_NAME_ERROR: {
            return {...state, name_error: action.payload};
        }
        case UPDATE_PARENT: {
            return {...state, parent: action.payload, calendar_id: action.payload && action.payload.data? action.payload.data.country: state.calendar_id, parent_error: ''};
        }
        case UPDATE_PUBLISH_DATE: {
            return {...state, private_until: action.payload};
        }
        case UPDATE_PUBLISH_TIME: {
            return {...state, publish_time: action.payload};
        }
        case UPDATE_RATING: {
            return {...state, rating: action.payload};
        }
        case UPDATE_TO_USER:{
            return {...state, to_user: action.payload};
        }
        case UPDATE_EMAIL:{
            return {...state, contact_email: action.payload};
        }
        case UPDATE_VISIBILITY: {
            return {...state, visibility: action.payload};
        }
        case UPDATE_VIDEO_LINK: {
            return {...state, video_link: action.payload};
        }
        case UPDATE_ZOOM: {
            return {...state, zoom: action.payload};
        }
        case SET_COLUMNS: {
            return {...state, columns: action.payload};
        }
        default:
            return state;
    }
};